<template>
  <div id="logout">saindo...</div>
</template>

<script>
import { store } from "@/store";

export default {
  name: "LogoutComponent",
  mounted() {
    store.forceQuit = true;
  },
};
</script>
